import $ from "jquery";

export default function onWindowLoad() {

    if(window.innerWidth > 992) {
        $('.wp-block-cover .avu-textbox-container:not(.image-outside-top):not(.image-outside-bottom)').each(function() {
            let textboxContainer = $(this);
            if (textboxContainer.parents('.wp-block-cover').length > 0) {
                let heightTextbox = textboxContainer.find('.avu-textbox').outerHeight() + 240;
                textboxContainer.parents('.wp-block-cover').css('min-height', heightTextbox + 'px');
            }
        });
        $(".avu-nav-desktop").attr("aria-hidden","false");
        $(".avu-nav-mobile").attr("aria-hidden","true");
        $(".avu-services-template-nav-mobile").attr("aria-hidden","true").addClass('d-none');
        $(".avu-services-template-nav-desktop").attr("aria-hidden","false").removeClass('d-none');
        $('#collapseMagazinCategory').removeClass("collapse");
        $('.avu-swiper-contact-container').removeClass("avu-swiper-contact");
        $('.avu-swiper-contact-container > .avu-contact-categories-list-container').removeClass("swiper-wrapper");
        $('.avu-swiper-contact-container > .avu-contact-categories-list-container .avu-contact-categories-list-item').removeClass("swiper-slide");
    }
    else {
            $('.wp-block-cover .avu-textbox-container').each(function() {
                let textboxContainer = $(this);
                if (textboxContainer.parents('.wp-block-cover').length > 0) {
                    let heightTextbox = textboxContainer.find('.avu-textbox').outerHeight() + 120;
                    textboxContainer.parents('.wp-block-cover').css('min-height', heightTextbox + 'px');
                }
            });
            $(".avu-nav-desktop").attr("aria-hidden","true");
            $(".avu-nav-mobile").attr("aria-hidden","false");
            $(".avu-services-template-nav-mobile").attr("aria-hidden","false").removeClass('d-none');
            $(".avu-services-template-nav-desktop").attr("aria-hidden","true").addClass('d-none');
            //Move social link
            let $lastLi = $('#menu-fussnavigation > li:last-child .submenu');
            $('#menu-fussnavigation > li:last-child').css('display', 'none');
            let $menuMobileItem = $('.menu-mobile-item');
            $menuMobileItem.append($lastLi);
            let $topLink = $('.avu-footer-navigation .avu-footer-go-top-container');
            $('.avu-footer-siegel-container').append($topLink);
            $('#collapseMagazinCategory').addClass("collapse");
            $('#collapseMagazinCategoryButton').attr("aria-hidden","false");
            $('.avu-swiper-contact-container').addClass("avu-swiper-contact");
            $('.avu-swiper-contact-container > .avu-contact-categories-list-container').addClass("swiper-wrapper");
            $('.avu-swiper-contact-container > .avu-contact-categories-list-container .avu-contact-categories-list-item').addClass("swiper-slide");

        }
    $('#question-product .accordion:first').addClass('current').addClass("question-active");
    $('#question-product .accordion:first + .panel').addClass('question-show');
    $('.avu-presse-date-list li:first-child').addClass('current');
    $('.avu-services-template-links li:first-child .avu-services-link').addClass('highlight');

    //Ökovariante
    $('.avu-cbx-eco-tariff').each(function() {
        let $tariffPriceEco = $(this).closest('div').siblings('.tariff-price-eco');
        let $tariffPrice = $(this).closest('div').siblings('.tariff-price');

        if ($(this).is(':checked')) {
            $tariffPriceEco.removeClass('d-none');
            $tariffPrice.addClass('d-none');
        } else {
            $tariffPriceEco.addClass('d-none');
            $tariffPrice.removeClass('d-none');
        }
    });

    function getParameterByName(name) {
        let url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
        var results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    let variant = getParameterByName('variant');
    if (variant === 'ecological') {
        $('.avu-cbx-eco-tarif-single').prop('checked', true);
    }

    if ($('main').hasClass('avu-tariff-details-template')) {
        if ($('.avu-single-result-container').length) {
            $('html, body').animate({
                scrollTop: $('.avu-single-result-container').offset().top - 250
            }, 0);
        }
    }

}
